(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Scroll to hash target if present
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // ─── Filter-aware image sync ───────────────────────────────────────────────
  // When a color filter is active, swap each product card's image to the
  // matching variant instead of waiting for the user to hover.

  function getActiveColorFilters() {
    const params = new URL(window.location.href).searchParams;
    const colors = [];

    // Shopify filter params come in two common shapes:
    //   filter.p.m.custom.color=White
    //   filter.p.option.color=White
    for (const [key, value] of params.entries()) {
      if (/filter\.p\.(m\.|option\.)?.*color/i.test(key)) {
        colors.push(value.toLowerCase().trim());
      }
    }
    return colors;
  }

  function triggerSwatchForColor(card, activeColors) {
    if (!activeColors.length) return;

    // Common swatch selectors used across Shopify themes
    const swatchSelectors = [
      '[data-color]',
      '[data-swatch-value]',
      '[data-option-value]',
      '[data-variant-option]',
      'input[type="radio"]',
      '.swatch__item',
      '.color-swatch',
    ];

    const swatches = card.querySelectorAll(swatchSelectors.join(', '));
    if (!swatches.length) return;

    for (const swatch of swatches) {
      // Pull the color label from wherever the theme stores it
      const swatchColor = (
        swatch.dataset.color ||
        swatch.dataset.swatchValue ||
        swatch.dataset.optionValue ||
        swatch.dataset.variantOption ||
        swatch.value ||
        swatch.getAttribute('aria-label') ||
        swatch.title ||
        ''
      ).toLowerCase().trim();

      if (activeColors.includes(swatchColor)) {
        // Fire all the events the hover/click handler listens for
        ['mouseenter', 'mouseover', 'focus', 'click'].forEach((eventType) => {
          swatch.dispatchEvent(new MouseEvent(eventType, { bubbles: true, cancelable: true }));
        });

        // For input[type="radio"] swatches, also set checked + change
        if (swatch.tagName === 'INPUT') {
          swatch.checked = true;
          swatch.dispatchEvent(new Event('change', { bubbles: true }));
        }

        break; // First match per card is enough
      }
    }
  }

  function syncImagesWithActiveFilters() {
    const activeColors = getActiveColorFilters();
    if (!activeColors.length) return;

    const cards = document.querySelectorAll('.product-grid__item');
    cards.forEach((card) => triggerSwatchForColor(card, activeColors));
  }

  // Run after DOM is ready
  document.addEventListener('DOMContentLoaded', syncImagesWithActiveFilters, { once: true });

  // Also re-run if results-list updates the DOM (infinite scroll / AJAX filters)
  const resultsListEl = document.querySelector('results-list');
  if (resultsListEl) {
    new MutationObserver(() => {
      syncImagesWithActiveFilters();
    }).observe(resultsListEl, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();
})();
